export default {"src":"/_next/static/media/0x6db236515e90fc831d146f5829407746eddc5296.0c104feb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};